export function multiMarkerFacesFromReseaux(dictionaryMarker, clePosition) {
  dictionaryMarker[clePosition].faces = [];
  dictionaryMarker[clePosition].indexFaceCourant = 0;
}

export function typesInformationsFacesFromReseaux(dictionaryMarker, clePosition, face) {
  dictionaryMarker[clePosition].selected = dictionaryMarker[clePosition].selected
    || face.selected;
  dictionaryMarker[clePosition].azimut = face.azimut;
  dictionaryMarker[clePosition].faces.push({
    adresse1: face.adresseCommercialeLibelle1,
    adresse2: face.adresseCommercialeLibelle2,
    adresse3: face.adresseCommercialeLibelle3,
    azimut: face.azimut,
    dispo: face.dispo,
    codeDepartement: face.codeDepartement,
    codeFormat: face.codeFormat,
    codeMateriel: face.codeMateriel,
    codePostal: face.codePostal,
    departement: face.departement,
    eclaire: face.eclaire ? 'Oui' : 'Non',
    facCode: face.facCode,
    facNum: face.facNum,
    format: face.format,
    surface: face.surface,
    libelleReseau: face.libelleReseau,
    materiel: face.materiel,
    panCode: face.panCode,
    panNum: face.panNum,
    ville: face.ville,
    img: 'http://via.placeholder.com/350x150',
    urlPhoto: face.urlPhoto,
  });

  const arraySurface = dictionaryMarker[clePosition].faces.map(el => el.surface);
  dictionaryMarker[clePosition].surface = Math.max(...arraySurface);
  dictionaryMarker[clePosition].color = face.color;
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurMarkersFacesReseaux.js